/**
 * Normalize REST payloads that may use snake_case (gRPC-style) or camelCase.
 */

export function strField(row: Record<string, unknown>, camel: string, snake: string): string {
  const a = row[camel];
  const b = row[snake];
  if (typeof a === 'string' && a.length > 0) return a;
  if (typeof b === 'string' && b.length > 0) return b;
  return '';
}

export function boolField(row: Record<string, unknown>, camel: string, snake: string): boolean {
  const a = row[camel];
  const b = row[snake];
  if (typeof a === 'boolean') return a;
  if (typeof b === 'boolean') return b;
  return false;
}
